<!-- <button mat-raised-button (click)="isLinear = !isLinear" id="toggle-linear">
    {{!isLinear ? 'Enable linear mode' : 'Disable linear mode'}}
  </button> -->
  <!-- Stepper Container -->
<div class="vertical-stepper" [attr.data-selected-index]="currentStep">

  <!-- Conditional Rendering Based on childEnvName -->
  <div *ngIf="stepperDetails.childEnvName">

    <!-- Step 1 -->
    <div class="step" [class.completed]="step1Completion" [class.error]="isStep1Failed">
      <div class="step-label">{{ stepperDetails.Label0 }}</div>
      <div class="step-content">
        <div *ngFor="let label of stepperDetails.childStatus">
          <div *ngIf="label.name === 'DATA_VALIDATION'" class="step-status">{{ label.status }}</div>
        </div>
      </div>
    </div>

    <!-- Step 2 -->
    <div *ngIf="stepperDetails.Label1" class="step" [class.completed]="step2Completion" [class.error]="isStep2Failed">
      <div class="step-label">{{ stepperDetails.Label1 }}</div>
      <div class="step-content">
        <div *ngFor="let label of stepperDetails.childStatus">
          <div *ngIf="label.name === 'DOMAIN_CREATION'" class="step-status">{{ label.status }}</div>
        </div>
      </div>
    </div>

    <!-- Step 3 -->
    <div class="step" [class.completed]="step3Completion" [class.error]="isStep3Failed">
      <div class="step-label">{{ stepperDetails.Label2 }}</div>
      <div class="step-content" *ngIf="stepperDetails.childStatus && stepperDetails.childEnvName === 'MASTER_DATA_UPLOAD'">
        <div *ngFor="let label of stepperDetails.childStatus">
          <div *ngIf="label.name === 'MASTER_DATA_UPLOAD'" class="step-status">{{ label.status }}</div>
        </div>
      </div>
    </div>

  </div>

  <!-- Fallback Step if childEnvName is not present -->
  <div *ngIf="!stepperDetails.childEnvName" class="step" [class.completed]="stepperDetails.completed" [class.error]="!stepperDetails.active" [attr.data-state]="stepperDetails.state">
    <div class="step-lable-container">
      <div class="dhl-type"><span>1</span></div>
      <div class="step-label">{{ stepperDetails.Label0 }}</div>
    </div>
    <div class="step-content">
      <div *ngFor="let label of stepperDetails.childStatus">
        <div class="step-status">{{ label.status }}</div>
        <div class="step-message">{{ label.message }}</div>
      </div>
    </div>
  </div>

</div>